webpackJsonp([260],{

/***/ 1192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlatformUserTable_vue__ = __webpack_require__(2903);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2acdb9ce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlatformUserTable_vue__ = __webpack_require__(5165);
function injectStyle (ssrContext) {
  __webpack_require__(5163)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2acdb9ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlatformUserTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2acdb9ce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlatformUserTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* unused harmony export trimParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeEmptyParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = setParams;
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* harmony export (immutable) */ __webpack_exports__["a"] = conveSomeDataType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSeachParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query);
        // 设置搜索参数
        vm.setSearchParams(queryParams);
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSeachParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSeachParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      params[key] = newParams[key];
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1357), __esModule: true };

/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1358);


/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(41);
var get = __webpack_require__(145);
module.exports = __webpack_require__(12).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 2903:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_mixins_table__ = __webpack_require__(1346);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__core_mixins_table__["b" /* default */]],

  data: function data() {
    return {
      search: {
        name: '',
        department_id: '',
        status: '',
        roles: [],
        usertype: [],
        desc: ''
      },
      options: {
        departments: [],
        status: [],
        roles: []
      },
      maps: {
        department: {},
        type: {},
        status: {}
      },
      searchFieldType: {
        roles: Array
      },
      platformlist: []
    };
  },
  created: function created() {
    var _this = this;

    var items = [request('getAllDepartments'), request('getAdminOptions')];
    request.all.page(items).then(axios.spread(function (departments, adminOptions) {
      _this.getAllRoles();(function (_ref) {
        var data = _ref.data;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(data.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            _this.maps.department[item.id] = item.name;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        _this.options.departments = data.data;
      })(departments);(function (_ref2) {
        var data = _ref2.data;

        _this.maps.type = data.type;
        _this.maps.status = data.status;

        for (var k in data.status) {
          _this.options.status.push({
            id: k,
            name: data.status[k]
          });
        }
      })(adminOptions);
    }));

    this.fetchPlatformlist();
  },


  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Vuex.mapActions(['getPlatformUsersIndex', 'deletePlatformUser']), {
    getAllRoles: function getAllRoles() {
      var _this2 = this;

      var currentPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

      request.page('getRolesIndex', {
        current_page: currentPage,
        per_page: perPage
      }).then(function (_ref3) {
        var data = _ref3.data;

        _this2.options.roles = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this2.options.roles), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.data));

        if (currentPage < data.total / perPage) {
          _this2.getAllRoles(++currentPage);
        }
      });
    },
    getTableData: function getTableData(params) {
      // 列表查询默认排除兼职管理员
      params['usertype_not'] = [4];
      return request.page('getPlatformUsersIndex', params);
    },
    onDelete: function onDelete(id) {
      var _this3 = this;

      this.$confirm('确认删除此用户?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        request.common('deletePlatformUser', id).then(function (res) {
          _this3.$message({
            showClose: true,
            message: '删除成功',
            type: 'success'
          });
          _this3.onSearch();
        });
      }).catch(function () {
        _this3.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    onCopy: function onCopy(id) {
      var _this4 = this;

      this.$confirm('确认复制此用户?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        request.common('copyPlatformUser', id).then(function (res) {
          _this4.$message({
            showClose: true,
            message: '复制成功',
            type: 'success'
          });
          _this4.onSearch();
        });
      });
    },
    fetchPlatformlist: function fetchPlatformlist() {
      var _this5 = this;

      this.platformlist = [];
      return request.common('getPermissionPlatformlist', {}).then(function (_ref4) {
        var _platformlist;

        var data = _ref4.data;

        _this5.platformlist.push(data.main);
        (_platformlist = _this5.platformlist).push.apply(_platformlist, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.others));
        _this5.platformlist.push({
          name: 'UI权限',
          host: null
        });
      });
    }
  })
});

/***/ }),

/***/ 5163:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5164);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("13b312f0", content, true, {});

/***/ }),

/***/ 5164:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".custom-form .re-el-form__flex[data-v-2acdb9ce]{margin:0}.custom-form .el-select[data-v-2acdb9ce]{width:100%}.custom-form .form-panel[data-v-2acdb9ce]{width:100%;margin:15px 0 0}.custom-form .form-slider[data-v-2acdb9ce]{padding:0 0 0 10px}.popover-table[data-v-2acdb9ce]{position:fixed;top:0;bottom:0;left:0;right:0;margin:0;background-color:rgba(0,0,0,.5);z-index:999}.popover-table .popover-table-body[data-v-2acdb9ce]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;max-height:80%;min-height:200px;max-width:80%;margin:auto;background-color:#fff;border-radius:5px;overflow:hidden}.popover-table .popover-table-body>div[data-v-2acdb9ce]{width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;padding:15px}.popover-table .popover-table-body .popover-table-header[data-v-2acdb9ce]{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;font-size:16px;font-weight:900;color:#666;border-bottom:1px dashed #aaa}.popover-table .popover-table-body .popover-table-content[data-v-2acdb9ce]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;overflow:auto}", "", {"version":3,"sources":["/workspace/src/views/platform-user/style/PlatformUser.scss"],"names":[],"mappings":"AACA,gDAAgD,QAAQ,CACvD,AACD,yCAAyC,UAAU,CAClD,AACD,0CAA0C,WAAW,eAAe,CACnE,AACD,2CAA2C,kBAAkB,CAC5D,AACD,gCAAgC,eAAe,MAAM,SAAS,OAAO,QAAQ,SAAS,gCAAiC,WAAW,CACjI,AACD,oDAAoD,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,4BAA4B,wBAAwB,uBAAuB,oBAAoB,2BAA2B,eAAe,iBAAiB,cAAc,YAAY,sBAAsB,kBAAkB,eAAe,CAC5Y,AACD,wDAAwD,WAAW,8BAA8B,sBAAsB,YAAY,CAClI,AACD,0EAA0E,mBAAmB,oBAAoB,YAAY,oBAAoB,cAAc,eAAe,gBAAgB,WAAW,6BAA6B,CACrO,AACD,2EAA2E,mBAAmB,oBAAoB,YAAY,oBAAoB,cAAc,aAAa,CAC5K","file":"PlatformUser.scss","sourcesContent":["\n.custom-form .re-el-form__flex[data-v-2acdb9ce]{margin:0\n}\n.custom-form .el-select[data-v-2acdb9ce]{width:100%\n}\n.custom-form .form-panel[data-v-2acdb9ce]{width:100%;margin:15px 0 0\n}\n.custom-form .form-slider[data-v-2acdb9ce]{padding:0 0 0 10px\n}\n.popover-table[data-v-2acdb9ce]{position:fixed;top:0;bottom:0;left:0;right:0;margin:0;background-color:rgba(0,0,0,0.5);z-index:999\n}\n.popover-table .popover-table-body[data-v-2acdb9ce]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;max-height:80%;min-height:200px;max-width:80%;margin:auto;background-color:#FFF;border-radius:5px;overflow:hidden\n}\n.popover-table .popover-table-body>div[data-v-2acdb9ce]{width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;padding:15px\n}\n.popover-table .popover-table-body .popover-table-header[data-v-2acdb9ce]{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;font-size:16px;font-weight:900;color:#666;border-bottom:1px dashed #AAA\n}\n.popover-table .popover-table-body .popover-table-content[data-v-2acdb9ce]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;overflow:auto\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.name),expression:"$route.name"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v(_vm._s(_vm.$route.name))]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.name))])],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/platform-user/audit-log"}},[_c('el-button',{staticStyle:{"position":"absolute","right":"10px","top":"5px"},attrs:{"type":"primary"}},[_c('i',{staticClass:"el-icon-s-order"},[_vm._v(" 审计日志")])])],1)],1),_vm._v(" "),_c('layout-panel',{staticClass:"table-panel",attrs:{"show-header":false}},[_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.$router.push({name: '新增后台用户'})}}},[_vm._v("添加后台用户\n    ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.$router.push({name: '部门管理'})}}},[_vm._v("部门管理\n    ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.$router.push({name: '权限组管理'})}}},[_vm._v("权限组管理\n    ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.$router.push({name: '后台用户角色管理'})}}},[_vm._v("角色管理\n    ")])],1),_vm._v(" "),_c('layout-panel',{attrs:{"collapse":true}},[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",staticClass:"layout-search-form medium",attrs:{"model":_vm.search,"label-width":"96px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',[_c('el-form-item',{attrs:{"label":"用户名称：","prop":"name"}},[_c('el-input',{attrs:{"clearable":""},model:{value:(_vm.search.name),callback:function ($$v) {_vm.$set(_vm.search, "name", $$v)},expression:"search.name"}})],1)],1),_vm._v(" "),_c('el-col',[_c('el-form-item',{attrs:{"label":"部门：","prop":"department_id"}},[_c('el-select',{attrs:{"clearable":""},model:{value:(_vm.search.department_id),callback:function ($$v) {_vm.$set(_vm.search, "department_id", $$v)},expression:"search.department_id"}},_vm._l((_vm.options.departments),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id.toString()}})}),1)],1)],1),_vm._v(" "),_c('el-col',[_c('el-form-item',{attrs:{"label":"状态：","prop":"status"}},[_c('el-select',{attrs:{"clearable":""},model:{value:(_vm.search.status),callback:function ($$v) {_vm.$set(_vm.search, "status", $$v)},expression:"search.status"}},_vm._l((_vm.options.status),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id.toString()}})}),1)],1)],1),_vm._v(" "),_c('el-col',[_c('el-form-item',{attrs:{"label":"角色：","prop":"roles"}},[_c('el-select',{attrs:{"multiple":"","clearable":""},model:{value:(_vm.search.roles),callback:function ($$v) {_vm.$set(_vm.search, "roles", $$v)},expression:"search.roles"}},_vm._l((_vm.options.roles),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id.toString()}})}),1)],1)],1),_vm._v(" "),_c('el-col',[_c('el-form-item',{attrs:{"label":"备注：","prop":"desc"}},[_c('el-input',{attrs:{"clearable":""},model:{value:(_vm.search.desc),callback:function ($$v) {_vm.$set(_vm.search, "desc", $$v)},expression:"search.desc"}})],1)],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit"}},[_vm._v("搜索\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.resetSearch()}}},[_vm._v("重置")])],1)],1)],1),_vm._v(" "),_c('layout-panel',{staticClass:"table-panel",attrs:{"show-header":false}},[_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.$router.push({name: '批量分配客户'})}}},[_vm._v("批量分配客户\n    ")]),_vm._v(" "),_vm._l((_vm.platformlist),function(permission){return _c('el-button',{key:permission.name,attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.$router.push({name: '批量分配权限角色', params: {type: permission.name}})}}},[_vm._v("批量分配"+_vm._s(permission.name)+"角色\n    ")])})],2),_vm._v(" "),_c('layout-panel',{attrs:{"show-header":false}},[_c('el-table',{ref:"multipleTable",attrs:{"data":_vm.table,"stripe":"","highlight-current-row":""}},[_c('el-table-column',{attrs:{"prop":"id","label":"序号"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"用户名"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"phone","label":"手机号"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mail_address","label":"邮箱"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"usertype","label":"类型"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.maps.type[scope.row.usertype] || '-'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"状态"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.maps.status[scope.row.status] || '-'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"department_id","label":"部门"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.maps.department[scope.row.department_id] || '-'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created_at","label":"创建时间"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(scope.row.created_at || '-'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"desc","label":"备注"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(scope.row.desc || '-'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"last_login","label":"最近登录"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(scope.row.last_login === '0000-00-00 00:00:00' ? '-' : scope.row.last_login))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"text","size":"mini"},on:{"click":function($event){return _vm.$router.push({name: '编辑后台用户', params: {userId: scope.row.id}})}}},[_vm._v("\n            修改\n          ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"text","size":"mini"},on:{"click":function($event){return _vm.onDelete(scope.row.id)}}},[_vm._v("删除\n          ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"text","size":"mini"},on:{"click":function($event){return _vm.onCopy(scope.row.id)}}},[_vm._v("复制\n          ")]),_vm._v(" "),_c('div',[(_vm.maps.type[scope.row.usertype] && scope.row.usertype !== 1)?_c('el-button',{attrs:{"type":"text","size":"mini"},on:{"click":function($event){return _vm.$router.push({path: ("/platform-user/ui-permissions/" + (scope.row.id))})}}},[_vm._v("\n              UI权限\n            ")]):_vm._e(),_vm._v(" "),_c('router-link',{attrs:{"to":'/platform-user-province/update/'+scope.row.id}},[_c('el-button',{attrs:{"type":"text","size":"mini"}},[_vm._v("分配用户资源\n              ")])],1)],1)]}}])})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/PlatformUserTable.64cdec87b832a4eb0326.js